import constant from '@/constant.js'
import util from '@/util.js'

export default {
  // loft
  createAccount: function (email, password, alias, firstName, lastName, mobilePhone, birthday, cb) {
    var data = { email, password, userName: email, firstName, lastName, alias, mobilePhone, birthday }
    util.apiHandler('post', `${constant.API_ROOT}/users/create`, data, cb)
  },
  authAccount: function (email, verifyToken, cb) {
    var data = { email, verifyToken }
    util.apiHandler('get', `${constant.API_ROOT}/users/verifyRegisterEmail`, data, cb)
  },
  sendResetPasswordMail: function (email, cb) {
    var data = { email }
    util.apiHandler('get', `${constant.API_ROOT}/users/verifyResetPassword`, data, cb)
  },
  resetPassword: function (verifyToken, email, password, cb) {
    var data = { verifyToken, email, password }
    util.apiHandler('post', `${constant.API_ROOT}/users/resetPassword`, data, cb)
  },
  signIn: function (email, password, cb) {
    var data = { email, password }
    util.apiHandler('post', `${constant.API_ROOT}/loginAuth`, data, cb)
  },
  // facebook
  signInFb: function (csrf, redirect) {
    var state = {
      csrf,
      redirect
    }
    var data = {
      client_id: constant.OAUTH_CLIENT_ID_FB,
      redirect_uri: encodeURIComponent(constant.OAUTH_REDIRECT_URI),
      response_type: 'code',
      scope: encodeURIComponent('email'),
      state: encodeURIComponent(JSON.stringify(state))
    }
    var url = 'https://www.facebook.com/v22.0/dialog/oauth'
    var getUrl = url
    for (var key in data) {
      getUrl += (getUrl === url ? '?' : '&')
      getUrl += (key + '=' + data[key])
    }
    window.location = getUrl
  },
  authFb: function (code, cb) {
    var data = { code }
    util.apiHandler('post', `${constant.API_ROOT}/loginByFaceBook`, data, cb)
  }
}
